import {
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  USER_SIGN_IN,
  USER_SIGN_IN_FAILED,
  USER_SIGN_OUT,
  CLEAR_LOGIN_ERROR,
  REQUEST_OTP,
  REQUEST_OTP_SUCCESS,
  REQUEST_OTP_FAILED,
  UPDATE_USER_WALLET_HISTORY,
  SEND_RESET_EMAIL,
  SEND_RESET_EMAIL_FAILED
} from "../store/types";

import store from '../store/store';
import { backend } from '../config/configureBackend';
import { child, onValue, push, update, set, off } from "../config/supabaseDatabaseCompat";
import { supabase } from '../config/supabaseClient';
import { onSupabaseAuthStateChanged, signOutSupabase } from '../config/supabaseAuth';
import { uploadAppFile } from '../data/appRecords';

export const fetchUser = () => (dispatch) => {
  const { singleUserRef } = backend;

  dispatch({
    type: FETCH_USER,
    payload: null
  });
  onSupabaseAuthStateChanged(user => {
    if (user) {
      onValue(singleUserRef(user.uid), async snapshot => {
        if (snapshot.val()) {
          let profile = snapshot.val();
          profile.uid = user.uid;
          dispatch({
            type: FETCH_USER_SUCCESS,
            payload: profile
          });
        }else{
          const provider = user.app_metadata?.provider;
          let data = {
            uid : user.uid,
            mobile: '',
            email: '',
            firstName: user.user_metadata?.firstName || '',
            lastName: user.user_metadata?.lastName || '',
            verifyId: '',
            usertype: user.user_metadata?.usertype || 'customer',
            walletBalance: 0,
            rating: '0',
            approved: false,
            driverActiveStatus: false,
          }

          if(user.email){
            data.email = user.email;
          }
          if(user.phoneNumber){
            data.mobile = user.phoneNumber;
          }
          if (provider === 'google' || provider === 'apple') {
            data.profile_image = user.user_metadata?.avatar_url || '';
            const fullName = user.user_metadata?.full_name || '';
            if (!data.firstName && fullName) {
              const [firstName, ...lastName] = fullName.split(' ');
              data.firstName = firstName || '';
              data.lastName = lastName.join(' ');
            }
          }
          await set(singleUserRef(user.uid), data);
          dispatch({ type: FETCH_USER_SUCCESS, payload: data });
        }
      });
    } else {
      const defaultLanguage = store.getState().languagedata.defaultLanguage || {};
      dispatch({
        type: FETCH_USER_FAILED,
        payload: {
          code: defaultLanguage.auth_error || 'auth_error',
          message: defaultLanguage.not_logged_in || 'Not logged in'
        }
      });
    }
  });
};

export const validateReferer = async (referralId) => {
  const { data, error } = await supabase.rpc('find_referrer_id', { p_referral_id: referralId });
  if (error) return {};
  return data?.[0] || {};
};

export const checkUserExists = async (data) => {
  const { data: exists, error } = await supabase.rpc('check_user_identifier', {
    p_email: data.email || null,
    p_mobile: data.mobile || null,
  });
  if (error) return { error: error.message };
  return { users: exists ? [{ exists: true }] : [] };
};

export const mainSignUp = async (regData) => {
  const { email, password, pass, ...metadata } = regData;
  delete metadata.confirmpassword;
  const { data, error } = await supabase.auth.signUp({
    email,
    password: password || pass,
    options: { data: metadata },
  });
  return error ? { error: error.message } : { uid: data.user?.id || null };
};

export const updateProfileWithEmail = (profileData) => async (dispatch) => {
  try{
    const { error } = await supabase.auth.updateUser({ email: profileData.email });
    if (error) return { success: false, error };
    const uid = backend.auth.currentUser.uid;
    await update(backend.singleUserRef(uid), profileData);
    return { success: true };
  }catch(error){
    return {success: false, error: error}
  }
}


export const requestPhoneOtpDevice = (phone) => async (dispatch) => {
  dispatch({ type: REQUEST_OTP, payload: true });
  const { error } = await supabase.auth.signInWithOtp({ phone });
  if (error) {
    dispatch({ type: REQUEST_OTP_FAILED, payload: error.message });
    return;
  }
  dispatch({ type: REQUEST_OTP_SUCCESS, payload: phone });
}

export const mobileSignIn = (phone, code) => async (dispatch) => {
  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  const { error } = await supabase.auth.verifyOtp({ phone, token: code, type: 'sms' });
  if (error) dispatch({ type: USER_SIGN_IN_FAILED, payload: error });
};

export const saveAddresses = async (uid, location, name) => {
  const { singleUserRef } = backend;
  onValue(child(singleUserRef(uid), "savedAddresses"), (savedAdd) => {
    if (savedAdd.val()) {
      let addresses = savedAdd.val();
      let didNotMatch = true;
      for (let key in addresses) {
        let entry = addresses[key];
        if (entry.name == name ) {
          didNotMatch = false;
          update(child(singleUserRef(uid),"savedAddresses/" + key),{
            description: location.add,
            lat: location.lat,
            lng: location.lng,
            count: 1,
            name: name
          });
          break;
        }
      }
      if (didNotMatch) {
        push(child(singleUserRef(uid),"savedAddresses"),{
          description: location.add,
          lat: location.lat,
          lng: location.lng,
          count: 1,
          name: name
        });
      }
    } else {
      push(child(singleUserRef(uid),"savedAddresses"),{
        description: location.add,
        lat: location.lat,
        lng: location.lng,
        count: 1,
        name: name
      });
    }
  }, {onlyOnce: true});
};

export const googleLogin = (idToken, accessToken) => (dispatch) => {
  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });

  supabase.auth.signInWithIdToken({ provider: 'google', token: idToken, access_token: accessToken || undefined })
    .then(({ error }) => {
      if (!error) return;
      console.log(error);
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
}

export const appleSignIn = (credentialData) => (dispatch) => {
  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  if (credentialData) {
    supabase.auth.signInWithIdToken({
      provider: 'apple',
      token: credentialData.idToken,
      nonce: credentialData.rawNonce,
    }).then(({ error }) => {
      if (error) {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: error
        });
      }
    });
  } else {
    supabase.auth.signInWithOAuth({ provider: 'apple' }).then(({ error }) => {
      if (error) dispatch({ type: USER_SIGN_IN_FAILED, payload: error });
    });
  }
};

export const signOff = () => (dispatch) => {

  const {
    auth,
    singleUserRef,
    walletHistoryRef,
    userNotificationsRef
  } = backend;

  const uid = auth.currentUser.uid;

  off(singleUserRef(uid));
  off(walletHistoryRef(uid));
  off(userNotificationsRef(uid));

  onValue(singleUserRef(uid), snapshot => {
      if(snapshot.val()){
        const profile = snapshot.val();
        if (profile && profile.usertype === 'driver') {
          update(singleUserRef(uid), {driverActiveStatus:false});
        }
        signOutSupabase().then(() => {
          dispatch({ type: USER_SIGN_OUT, payload: null });
        }).catch(() => {});
      }
  },{onlyOnce: true});
};

export const updateProfile = (updateData) => async (dispatch) => {

  const {
    auth,
    singleUserRef,
  } = backend;

  const uid = auth.currentUser.uid;
  
  if (updateData.licenseImage) {
    updateData.licenseImage = await uploadAppFile('users', `${uid}/license`, updateData.licenseImage);
  }
  if (updateData.licenseImageBack) {
    updateData.licenseImageBack = await uploadAppFile('users', `${uid}/licenseBack`, updateData.licenseImageBack);
  }
  if (updateData.verifyIdImage) {
    updateData.verifyIdImage = await uploadAppFile('users', `${uid}/verifyIdImage`, updateData.verifyIdImage);
  }

  update(singleUserRef(uid), updateData);
};


export const updateProfileImage = (imageBlob) => {

  const {
    auth,
    singleUserRef,
  } = backend;

  const uid = auth.currentUser.uid;

  uploadAppFile('profiles', uid, imageBlob).then((url) => {
    imageBlob?.close?.();
    update(singleUserRef(uid), {
      profile_image: url
    });
  })
};

export const updateWebProfileImage = async (imageBlob) => {

  const {
    auth,
    singleUserRef,
  } = backend;

  const uid = auth.currentUser.uid;

  const image = await uploadAppFile('profiles', uid, imageBlob);
  update(singleUserRef(uid), {profile_image: image});

};
export const updateCustomerProfileImage = async (imageBlob, id) => {

  const {
    singleUserRef,
  } = backend;

  const uid = id

  const image = await uploadAppFile('profiles', uid, imageBlob);
  update(singleUserRef(uid), {profile_image: image});

};

export const updatePushToken = (token, platform)  => {

  const {
    auth,
    singleUserRef,
  } = backend;

  const uid = auth.currentUser.uid;

  update(singleUserRef(uid), {
    pushToken: token,
    userPlatform: platform
  });
};

export const clearLoginError = () => (dispatch) => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
    payload: null
  });
};

export const fetchWalletHistory = () => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = backend;

  const uid = auth.currentUser.uid;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }
  });
};
export const fetchUserWalletHistory = (userId) => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = backend;

  const uid = userId;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }else{
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload:[]
      });
    }
  });
};

export const sendResetMail = (email) => async (dispatch) => {
  dispatch({
    type: SEND_RESET_EMAIL,
    payload: email
  });
  supabase.auth.resetPasswordForEmail(email).then(({ error }) => {
    if (!error) {
    console.log('Email send successfuly');
      return;
    }
      dispatch({
        type: SEND_RESET_EMAIL_FAILED,
          payload: {
            code: (store.getState().languagedata.defaultLanguage || {}).auth_error || 'auth_error',
            message: (store.getState().languagedata.defaultLanguage || {}).not_registred || 'User is not registered'
          }
        });
  });
};

export const verifyEmailPassword = (email, pass) => async (dispatch) => {
  const { error } = await supabase.auth.signInWithPassword({ email, password: pass });
  if (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
  }
}

export const requestMobileOtp = (mobile) => async (dispatch) => {
  return requestPhoneOtpDevice(mobile)(dispatch);
}

export const requestPhoneChangeOtp = (mobile) => async (dispatch) => {
  dispatch({ type: REQUEST_OTP, payload: true });
  const { error } = await supabase.auth.updateUser({ phone: mobile });
  if (error) {
    dispatch({ type: REQUEST_OTP_FAILED, payload: error.message });
    return;
  }
  dispatch({ type: REQUEST_OTP_SUCCESS, payload: mobile });
}

export const verifyMobileOtp = (mobile, otp) => async (dispatch) => {
  return mobileSignIn(mobile, otp)(dispatch);
}

export const updateAuthMobile = async ( mobile, otp) => {
  const { error } = await supabase.auth.verifyOtp({ phone: mobile, token: otp, type: 'phone_change' });
  return error ? { success: false, error } : { success: true };
}
